module.exports = __webpack_public_path__ + "images/lpage-exams-2.png";